export class ContextInfo {
	userId: string;
}

export class RatePolicyRequest {

	correlationId: string;
	groupOperationId: string;
	policyNumber: string;
	requestSource: string;	
	contextInfo: ContextInfo = { userId: '' };
	generateRateArtifacts: boolean;
	calculate: 	boolean;
	issuePolicy: boolean;

	constructor(init?: Partial<RatePolicyRequest>) {
		Object.assign(this, init);
	}
}

export class RatePolicyResponse {
	id: string;
	policyNumber: string;
	elapsedMilliseconds: number;
	statisticsLog: string;
	descriptiveStatisticsLog: string;
	traceWorksheetUrl: string;
	premiumSummary: PolicyPremiumSummary;

	constructor(init?: Partial<PolicyPremiumSummary>) {
		Object.assign(this, init);
	}
}

export class PolicyPremiumSummary {
	currentPremium?: number;
	newPremium?: number;
	lines: LinePremiumSummary[] = [];

	constructor(init?: Partial<PolicyPremiumSummary>) {
		Object.assign(this, init);
	}
}

export class LinePremiumSummary {
	insuranceLineCode!: string;
	currentPremium?: number;
	newPremium?: number;
	coverages: CoveragePremiumSummary[] = [];
	units: UnitCoverageSummary[] = [];

	constructor(init?: Partial<LinePremiumSummary>) {
		Object.assign(this, init);
	}
}

export class UnitCoverageSummary {
	insuranceLineCode!: string;
	productCode!: string;
	location!: number;
	sublocation!: number;
	unit!: number;
	state!: string;
	currentPremium?: number;
	newPremium?: number;
	coverages: CoveragePremiumSummary[] = [];

	constructor(init?: Partial<UnitCoverageSummary>) {
		Object.assign(this, init);
	}
}

export class CoveragePremiumSummary {
	coverageCode!: string;
	insuranceLineCode!: string;
	productCode!: string;
	location!: number;
	subLocation!: number;
	unit!: number;
	sequence!: number;
	state!: string;
	recordStatusIndicator!: string;
	currentPremium?: number;
	newPremium?: number;

	constructor(init?: Partial<CoveragePremiumSummary>) {
		Object.assign(this, init);
	}
}